import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalVppProgramsDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalVppPrograms(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryProposalVppProgramsDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.vppPrograms(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getVppPrograms(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
